
function MessageToUse(props) {
    return (
        <>
            <strong>{props.title}</strong> {props.text}<br></br>
        </>
    );
}

export default MessageToUse;